export enum SchoolStateEnum {
    Loaded = "Loaded",
    Requested = "Requested",
    Approved = "Approved",
    Rejected = "Rejected",
}